import {
    Card,
    Col,
    Row,
} from "reactstrap"
import Dropzone from "react-dropzone"
import React from "react";

export const ImageDropZonePreview = (props) => {

    const { onChange, selectedFiles } = props;

    const handleAcceptedFiles = files => {
        files.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            })
        )
        onChange({ selectedFiles: files })
    }

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    return (
        <React.Fragment>
            <Dropzone
                onDrop={acceptedFiles =>
                    handleAcceptedFiles(acceptedFiles)
                }
            >
                {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                        <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                        >
                            <input
                                {...getInputProps()}
                                accept={props.accept} />
                            <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                            </div>
                            {/*<h5>Drop files here or click to upload.</h5>*/}
                        </div>
                    </div>
                )}
            </Dropzone>
            <div
                className="dropzone-previews mt-3"
                id="file-previews"
            >
                {selectedFiles.map((f, i) => {
                    return (
                        <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                        >
                            <div className="p-2">
                                <Row className="align-items-center">
                                    <Col className="col-auto">
                                        <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                        />
                                    </Col>
                                    <Col>
                                        <button

                                            className="text-muted font-weight-bold"
                                        >
                                            {f.name}
                                        </button>
                                        <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    )
                })}
            </div>
        </React.Fragment>
    )
}